import { applyJitter } from "./helpers.mjs";
//#region src/backoff-strategy/exponential-full-jitter.ts
/**
* Exponential backoff with AWS-style full jitter.
*
* - `baseDelay = min(maxDelay, delay * 2^(attempt - 1))` for attempt < `maxAtAttempt`
* - `baseDelay = maxDelay` once attempt >= `maxAtAttempt` (default 20),
*   short-circuiting the multiplication to avoid huge numbers that would be
*   clamped to `maxDelay` anyway
*
* Returned delay is uniformly drawn from `[0, baseDelay]`. With `attempt = 1`
* (the first retry) the base equals `delay`.
*
* See https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
*/
const exponentialBackoffFullJitter = (options) => {
	const { delay, maxDelay, maxAtAttempt = 20 } = options;
	return (attempt) => {
		const baseDelay = attempt < maxAtAttempt ? Math.min(maxDelay, delay * 2 ** (attempt - 1)) : maxDelay;
		return applyJitter(baseDelay);
	};
};
//#endregion
export { exponentialBackoffFullJitter };
